module.exports = __webpack_public_path__ + "static/media/hall-PE-2026.6c124690.svg";